import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {connect} from 'react-redux';

import Box from '@mui/material/Box';

import MapTools from './map-tools';
import MosaicMap from './mosaic-map';
import SearchInput from './search-input';

import {MAPBOX_ACCESS_TOKEN} from '../config';
import {
  compare as compareMosaic,
  select as selectMosaic,
} from '../actions/mosaics';
import {
  getComparingMosaic,
  getSelectedMosaic,
  selectMosaicsData,
} from '../selectors';
import {includeExtent} from '../actions/map';
import {modes} from '../actions/ui';

const MapContainer = props => {
  const [cursorMapIndex, setCursorMapIndex] = useState(-1);

  const onMosaicDrop = (name, compare) => {
    const mosaic = props.mosaics.find(mosaic => mosaic.name === name);
    if (mosaic) {
      props.includeExtent(mosaic.bbox);
      if (compare) {
        return props.compareMosaic(mosaic.name);
      }
      return props.selectMosaic(mosaic.name);
    }
  };

  const onMapEnter = index => {
    setCursorMapIndex(index);
  };

  const onMapLeave = () => {
    setCursorMapIndex(-1);
  };

  return (
    <Box display="flex" flexGrow={1} position="relative">
      <MosaicMap
        mosaic={props.mosaic}
        onDrop={onMosaicDrop}
        onMouseEnter={() => onMapEnter(1)}
        onMouseLeave={onMapLeave}
        cursorVisible={cursorMapIndex === 0}
        withLabel={props.comparing}
      />
      {props.comparing && (
        <MosaicMap
          withLabel
          mosaic={props.comparison}
          onDrop={name => onMosaicDrop(name, true)}
          onMouseEnter={() => onMapEnter(0)}
          onMouseLeave={onMapLeave}
          cursorVisible={cursorMapIndex === 1}
          style={{borderLeft: '1px solid white'}}
        />
      )}
      {MAPBOX_ACCESS_TOKEN && <SearchInput />}
      <MapTools />
    </Box>
  );
};

MapContainer.propTypes = {
  comparing: PropTypes.bool.isRequired,
  comparison: PropTypes.object,
  mosaic: PropTypes.object,
  mosaics: PropTypes.array.isRequired,
  includeExtent: PropTypes.func,
  compareMosaic: PropTypes.func,
  selectMosaic: PropTypes.func,
};

const mapStateToProps = state => ({
  comparing: state.ui.mode === modes.COMPARE,
  comparison: getComparingMosaic(state),
  mosaic: getSelectedMosaic(state),
  mosaics: selectMosaicsData(state),
});

const mapDispatchProps = {
  includeExtent,
  compareMosaic,
  selectMosaic,
};

export default connect(mapStateToProps, mapDispatchProps)(MapContainer);
